/**
 * Get logged in user data
 * @return {{userProfession: (*|string), userState: (*|string), userId: (*|string), email: (*), userSpecialty: (*|string)}|{}}
 */
async function getUserParams() {
	if( ! window.hmUtils ) {
		return {};
	}
	const loggedInUserData = window.hmUtils.getUserData();
	const subscriberData = loggedInUserData && loggedInUserData.subscriber;
	const medicalData = loggedInUserData && loggedInUserData.medicalData;
	let specialty = medicalData && medicalData.specialty ? medicalData.specialty.name : '';
	let profession = medicalData && medicalData.profession ? medicalData.profession.name : '';
	const address = loggedInUserData && loggedInUserData.address;

	let emailHash = subscriberData && window.hmUtils.getHashedEmail();
	let userID = subscriberData ? subscriberData.subscriberId : '';
	if( window.hmOIDCRegistration ) {
		const userProfileCookie = window.Cookies.get( 'user_profile' );
		const userProfile = userProfileCookie && userProfileCookie !== 'undefined' && JSON.parse( userProfileCookie );
		emailHash = userProfile && await window.hmUtils.getHashedString( userProfile.email );
		userID = userProfile && userProfile.sub;
		specialty = userProfile && userProfile.specialty;
		profession = userProfile && userProfile.profession;
	}
	// parameters from URL //
	const emailFromURL = window.hmUtils.getParameterByName( 'sha256email' );
	emailHash = emailFromURL ? emailFromURL : emailHash;

	return {
		'emailHash' : emailHash,
		'userId' : userID,
		'addressState' : address ? address.stateCode : '',
		'specialty' : specialty,
		'profession' : profession,
		'pagePaywall' : false,
	};
}

/**
 * Get data from various Identity Provider Services
 * @return {{cpn: *, npi: *}}
 */
function getIdentityServicesParams() {
	let NPINumber = window.Cookies && window.Cookies.get( 'hmNpiId' );
	const cpn = window.hmUtils && window.hmUtils.getCPNValue();

	// parameters from URL //
	const npiFromURL = window.hmUtils.getParameterByName( 'nid' );
	NPINumber = npiFromURL ?  npiFromURL : NPINumber;
	return {
		'npi' : NPINumber,
		'cpn' : cpn
	};
}

/**
 * Generate the final object with data that needs to be sent to Infinity on window load.
 * @return {{}}
 */
function getOnLoadInfinityTagParameters() {
	// parameters from URL //
	const dgidFromURL = window.hmUtils.getParameterByName( 'hmdgid' );
	let dgid = dgidFromURL ? dgidFromURL : window.aimData && window.aimData.dgid;
	const infinityParams =  {
		'dgid' : dgid
	};
	return formatInfinityTagParameters( infinityParams );
}

/**
 * Generate the final object with data that needs to be sent to Infinity on Page View.
 * @return {{}}
 */
async function getPageViewInfinityTagParameters() {
	const userLoggedInParams = await getUserParams();
	const infinityParams = Object.assign( {}, userLoggedInParams, getIdentityServicesParams() );
	return formatInfinityTagParameters( infinityParams );
}

/**
 * The keys should follow the format hm.key
 * Unset the keys that are blank
 * @param infinityParams
 * @return {{}}
 */
function formatInfinityTagParameters( infinityParams ) {
	const mappedInfinityParams = Object.keys( infinityParams ).map( key => {
		const customKey = window.oracleInfinityTag ? window.oracleInfinityTag.customKey : '';
		const newKey = `${customKey}${key}`;
		return infinityParams[key] && { [newKey]: infinityParams[key] };
	} );
	return Object.assign( {}, ...mappedInfinityParams );
}

/**
 * Function to get oracle Cookie ID
 * @return {*|string}
 */
function getOracleCookieId() {
	const oracleCookie = window.Cookies && window.Cookies.get( 'ORA_FPC' );
	let oracleCookieID = oracleCookie ? oracleCookie.split( 'id=' ) : '';
	if( oracleCookieID.length > 1 ) {
		return oracleCookieID[1];
	}
	return oracleCookieID;
}

export { getPageViewInfinityTagParameters, getOnLoadInfinityTagParameters, getOracleCookieId, getUserParams };